export default {
  applicationID: 'ApplicationID',
  checkServeAPiInstrument: 'How to use serve\'s APIs',
  hide: 'Hide',
  reset: 'Reset',
  show: 'Show',
  change: 'Modify',
  testOnline: 'TestOnline',
  ok: 'Ok',
  cancel: 'cancel',
  test: 'Test',
  authName: 'AuthName',
  authDescription: 'AuthDescription',
  status: 'Status',
  operation: 'Operation',
  eventType: 'EventType',
  description: 'Description',
  callBackUrl: 'CallbackURL',
  opened: 'Opened',
  notOpen: 'NotOpen',
  reject: 'Reject',
  approving: 'Approving',
  applyAuth: 'ApplyAuth',
  cancelAuth: 'CancelAuth',
  change: 'Modify',
  isRubikCube: `Participate in the Shimmer Program and quickly build light apps with the application Rubik's Cube`,
  isPurchase: `Apply Rubik's Cube to quickly orchestrate your light apps`
};
